var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-modal', {
    attrs: {
      "color-overlay": "#b979e533",
      "content-position": _vm.contentPosition
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "slot": "content-wrapper"
    },
    slot: "content-wrapper"
  }, [_c('div', {
    ref: "scrollContent",
    staticClass: "modal-content"
  }, [_c('h4', {
    staticClass: "modal-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('choose.reason.for.check.annulment'))
    }
  }), _c('div', {
    staticClass: "receipt-cancel-reasons-list"
  }, _vm._l(_vm.receiptCancelReasons, function (_ref) {
    var code = _ref.code,
        icon = _ref.icon,
        description = _ref.description;
    return _c('div', {
      key: code,
      staticClass: "receipt-cancel-reason",
      on: {
        "click": function click($event) {
          return _vm.onReceiptCancel(code);
        }
      }
    }, [_c('capusta-panel', {
      attrs: {
        "icon": icon,
        "description": description
      }
    })], 1);
  }), 0), _c('div', {
    staticClass: "modal-button-container"
  }, [_c('button', {
    staticClass: "modal-button cancel",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }